module.exports = {
      id: "more-outline-usage",
      viewBox: "0 0 25 25",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#more-outline",
      toString: function () {
        return this.url;
      }
    }